//LANGUAGE
//import i18next from "i18next";

//UTILES INFORMES STJ

export const resuelveFilaComplejo = (dato, columnasApiComplejo, noColumnas, saltoPagina, tabulador=0, estilo=[] ) => {
  const miEstilo = estilo.length === 0 ? ['cblue', 'h3'] : estilo
  let array = []
  for(let t=0; t<tabulador; t++){array.push({ text:''})}
  columnasApiComplejo.forEach(element => {
      array.push({ 'text': dato[element] , style: miEstilo})
  });
  const longitud = noColumnas - array.length
  const salto = saltoPagina ? {pageBreak: 'before'} : ''
  for(let i=0; i<longitud; i++){
      
      if(i=== longitud-1){
          array.push({'text':'', style: miEstilo, salto})
      }else{
          array.push({'text':'', style: miEstilo})
      }
  }
  
  return array
}

export const resuelveFila = (dato, columnasApi, estilo=[]) => {
  let array = []
  columnasApi.forEach(element => {
      array.push({ 'text': dato[element], style: estilo })
  });
  return array
}

//pon header tabla
export const ponHeaderTabla = (noColumnas, titulosTabla, saltoPagina = false, tabulador=0, estilo=[]) => {
  const miEstilo = estilo.length === 0 ? ['fwhiteBrown', 'bold', 'h4'] : estilo
  let array = []
  for(let t=0; t<tabulador; t++){array.push({ text:''})}
  const restoColumnas = noColumnas-titulosTabla.length-array.length
  titulosTabla.forEach(element => {
    array.push({ 'text': element, style: miEstilo })

  });
  for(let i=0; i<restoColumnas; i++){
    array.push({ 'text': '', style: miEstilo })
  }
  return array
}

//inserta una fila con combinación de celdas, texto y salto de página before
export const filaColSpanText = (noColumnas, colSpan, texto, saltoPagina, estilo=[]) => {
  let array=[]
  for(let i=0; i<noColumnas; i++){ 
      array.push(i === 0 ? { 'text': texto , 'colSpan':colSpan, 'pageBreak' : saltoPagina ? 'before': '', 'style': estilo} : { 'text': '' , 'style': estilo })
  }
  return array
}

//inserta una fila con combinación de celdas y objeto. imagen, canvas ...
export const filaColSpanObj = (noColumnas, colSpan, objeto) => {
  let array=[]
  for(let i=0; i<noColumnas; i++){ 
      array.push(i === 0 ? objeto : { 'text': '' })
  }
  return array
}

//inserta fila vacía del nº de columnas necesaria
export const filaVacia = (noColumnas) => {
  let array=[]
  for(let i=0; i<noColumnas; i++){ array.push({ 'text': '' })}
  return array
}

//retonra un array con los anchos de columna automáticos
export const retornaArrayAncho = (noColumnas = 4, ancho = 100, porcentaje, auto = false) => {
  const anchoCol = ancho/noColumnas
  let array=[]
  for(let i=0; i<noColumnas; i++){ 
    array.push(auto ? 'auto': anchoCol+porcentaje)
  }
  return array
}

//meses
export const meses = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

//tamaño página para reporte de LCCS
export const lccsPageSize = (minYear, maxYear) => {
  let pageSize;
  if (maxYear - minYear < 8) {
    //A4
    pageSize = "A4";
  } else if (maxYear - minYear < 13) {
    //A3
    pageSize = "A3";
  } else if (maxYear - minYear < 19) {
    //A2
    pageSize = "A2";
  } else if (maxYear - minYear < 29) {
    //A1
    pageSize = "A1";
  } else if (maxYear - minYear < 44) {
    //A1
    pageSize = "A0";
  } else if (maxYear - minYear < 63) {
    //A1
    pageSize = "2A0";
  } else {
    //A0
    pageSize = "4A0";
  }
  return pageSize;
}


//DEVUELVE FORMATO FECHA
export const formatDate = (fecha, formato) => {
    let ye = new Intl.DateTimeFormat('ES', { year: 'numeric' }).format(fecha);
    let mo = new Intl.DateTimeFormat('ES', { month: formato }).format(fecha);
    let da = new Intl.DateTimeFormat('ES', { day: '2-digit' }).format(fecha);
    // let ye = new Intl.DateTimeFormat(i18next.language, { year: 'numeric' }).format(fecha);
    // let mo = new Intl.DateTimeFormat(i18next.language, { month: formato }).format(fecha);
    // let da = new Intl.DateTimeFormat(i18next.language, { day: '2-digit' }).format(fecha);
  return `${da} ${mo} ${ye}`;
}

//DEVUELVE ESTILO DE FILA DE READING
export const tomaEstilo = (comentario, faulty) => {
  let selecc;
  switch (comentario) {
    case "First reading on TAL":
    case "Reading OK":
      selecc = "normal";
      break;
    case "This asset is faulty or has changed its status of faulty. Please take photo of fault and upload":
      selecc = "red";
      break;
    default:
      selecc = "orange";
      break;
  }
  //eturn faulty ? "red" : selecc;
  return selecc;
};

//ESTILOS DE REPORTE ESTANDARES TAL
export const myStyle = {
    h0: {fontSize: 24,},
    h1: {fontSize: 18,},
    h2: {fontSize: 15,},
    h3: {fontSize: 12,},
    h4: {fontSize: 10,},
    h5: {fontSize: 8,},
    h6: {fontSize: 6,},

    bold: {bold: true,},
    italic: {italics: true,},

    cblack: {color: "black",},
    cwhite: {color: "white",},
    cblue:  {color: "#2B599F",},
    cbrown: {color: "#8D643B",},
    cgray:  {color: "gray",},

    right: {alignment: "right",},
    left: {alignment: "left",},
    center: {alignment: "center",},

    fazul: {
        color: "white",
        //borderColor: "#254C87",
        fillColor: "#2B599F",
        //borderWidth: 0.5,
        bold: true,
        
    },
    fbrown: {
        color: "white",
        //borderColor: "#785532",
        fillColor: "#8D643B",
        //borderWidth: 0.5,
        bold: true,
        
    },
    fwhiteBrown: {
      color: "#8D643B",
      borderColor: "#8D643B",
      fillColor: "#8D643B",
      borderWidth: 1,
      fillOpacity: 0.2,
      bold: true,
    },
    fwhiteBlue: {
      color: "#2B599F",
      borderColor: "#2B599F",
      fillColor: "#2B599F",
      borderWidth: 1,
      fillOpacity: 0.2,
      bold: true,
    },
    fgray: {
        borderColor: "#B0B0B0",
        fillColor: "#CCCCCC",
        borderWidth: 0.5,
        color: "black",
    },

    mt5: {margin:  [0, 5, 0, 15], },
    m10: {margin:  [5, 20, 5, 20], },
    m20: {margin:  [5, 20, 5, 15], },
    m50: {margin:  [5, 50, 5, 15], },
    m100: {margin:  [5, 100, 5, 15], },
    m200: {margin:  [5, 200, 5, 15], },
    m300: {margin:  [5, 300, 5, 15], },
    m400: {margin:  [5, 300, 5, 15], },
    m500: {margin:  [5, 300, 5, 155], }

};


//TABLA DE ESTILOS UTILIZADA
export const tablaEstilos = (myLayout) => {
  return {
    layout: myLayout,
    table: {
      // headers are automatically repeated if the table spans over multiple pages
      // you can declare how many rows should be treated as headers
      headerRows: 0,
      widths: ["25%"],
      body: [
        [{ text: "header", style: ["header"], }],
        [{ text: "pinkHeader", style: ["pinkHeader"], }],
        [{ text: "subHeader", style: ["subHeader"], }],
        [{ text: "subSubHeader", style: ["subSubHeader"], }],
        [{ text: "quote", style: ["quote"], }],
        [{ text: "normal", style: ["normal"], }],
        [{ text: "green", style: ["green"], }],
        [{ text: "yellow", style: ["yellow"], }],
        [{ text: "orange", style: ["orange"], }],
        [{ text: "black", style: ["black"], }],
        [{ text: "rosita", style: ["rosita"], }],
        [{ text: "red", style: ["red"], }],
        [{ text: "small", style: ["small"], }],
        [{ text: "tableHeader", style: ["tableHeader"], }],
        [{ text: "tableHeaderGrey", style: ["tableHeaderGrey"], }],
      ],
    },
  }
}

//TABLE LAYOUT
export const myLayout = {
  hLineWidth: function (i, node) {
    return i === 0 || i === node.table.body.length ? 0.75 : 0.25;
  },
  vLineWidth: function (i, node) {
    return i === 0 || i === node.table.widths.length ? 0.75 : 0.25;
  },
  hLineColor: function (i, node) {
    return i === 0 || i === node.table.body.length ? "lightGray" : "lightGray";
  },
  vLineColor: function (i, node) {
    return i === 0 || i === node.table.widths.length ? "lightGray" : "lightGray";
  },
  fillColor: function (rowIndex, node, columnIndex) {
    return rowIndex % 2 === 0 ? "#fEfEfE" : null;
  },
  layout:'noBorders'
  // hLineStyle: function (i, node) { return {dash: { length: 10, space: 4 }}; },
  // vLineStyle: function (i, node) { return {dash: { length: 10, space: 4 }}; },
  // paddingLeft: function(i, node) { return 4; },
  // paddingRight: function(i, node) { return 4; },
  // paddingTop: function(i, node) { return 2; },
  // paddingBottom: function(i, node) { return 2; },
  // fillColor: function (rowIndex, node, columnIndex) { return null; }
};
//FIN LAYOUT


/*
EJEMPLOS DE TAMAÑOS DE PAPEL
'4A0', '2A0', 'A0', 'A1', 'A2', 'A3', 'A4', 'A5', 'A6', 'A7', 'A8', 'A9', 'A10',
'B0', 'B1', 'B2', 'B3', 'B4', 'B5', 'B6', 'B7', 'B8', 'B9', 'B10',
'C0', 'C1', 'C2', 'C3', 'C4', 'C5', 'C6', 'C7', 'C8', 'C9', 'C10',
'RA0', 'RA1', 'RA2', 'RA3', 'RA4',
'SRA0', 'SRA1', 'SRA2', 'SRA3', 'SRA4',
'EXECUTIVE', 'FOLIO', 'LEGAL', 'LETTER', 'TABLOID'

{
  pageOrientation: 'portrait',
  content: [
    {text: 'Text on Portrait'},
    {text: 'Text on Landscape', pageOrientation: 'landscape', pageBreak: 'before'},
    {text: 'Text on Landscape 2', pageOrientation: 'portrait', pageBreak: 'after'},
    {text: 'Text on Portrait 2'},
  ]
}
*/

/*
  //datos del chart
  let data = {
    labels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul"],
    datasets: [
      {
        label: "Dataset #1",
        backgroundColor: "rgba(255,99,132,0.2)",
        borderColor: "rgba(255,99,132,1)",
        borderWidth: 2,
        hoverBackgroundColor: "rgba(255,99,132,0.4)",
        hoverBorderColor: "rgba(255,99,132,1)",
        data: [65, 59, 20, 81, 56, 55, 40],
      },
    ],
  };

  let options = {
    animation: {
      duration: 0,
    },
    scales: {
      yAxes: [
        {
          stacked: true,
          gridLines: {
            display: true,
            color: "rgba(255,99,132,0.2)",
          },
        },
      ],
      xAxes: [
        {
          gridLines: {
            display: false,
          },
        },
      ],
    },
  };

  let base64 = createChartImg("bar", data, options);
  //fin datos del chart
*/

/*
  if ((maxYear-minYear)<8){
    //A4
    pageSize='A4';
  }else if((maxYear-minYear)<13){
    //A3
    pageSize='A3';
  }else if((maxYear-minYear)<19){
    //A2
    pageSize='A2';
  }else if((maxYear-minYear)<29){
    //A1
    pageSize='A1';
  }else if((maxYear-minYear)<44){
    //A1
    pageSize='A0';
  }else if((maxYear-minYear)<63){
    //A1
    pageSize='2A0';
  }else{
    //A0
    pageSize='4A0';
  }
*/